export default {
  mounted() {
    let input_id = this.el.getAttribute('id')

    // The id here should be the id of the hidden input (or other element)
    // that stores the input value for the form we will emit a change for.
    this.handleEvent(input_id, () => {
      this.el.dispatchEvent(new Event('change', { bubbles: true }))
    })
  }
}
